module.exports = __webpack_public_path__ + "static/media/logo-di.48b517d4.svg";